import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  Checkbox,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import "./EditpermissionTable.scss";
import { getRequest } from "../../../../services/api/axios_api_Request";

const EditPermissionsTable = ({
  permissions,
  appData,
  setPermissions,
  handlePermissionChange,
  handleDeletePermission,
}) => {
  const [fetchedAccessLevels, setFetchedAccessLevels] = useState([]);
  useEffect(() => {
    const fetchAccessLevels = async () => {
      try {
        const res = await getRequest("admin/unique-access-levels");
        if (res?.status === 200) {
          const accessLevelData = res?.data?.access_levels || [];
          setFetchedAccessLevels(accessLevelData); // Set fetched fetchedAccessLevels
        } else {
          console.error("Failed to fetch access levels:", res);
        }
      } catch (error) {
        console.error("Error fetching access levels:", error);
      }
    };

    fetchAccessLevels(); // Call fetchAccessLevels on component mount
  }, []);

  const fetchAccessLevelPermissions = async (access_level_id, index) => {
    console.log("Fetching permissions for access_level_id:", access_level_id); // Log the access_level_id for debugging
    try {
      const res = await getRequest("admin/add-access-level-permission", {
        access_level_id: access_level_id, // Ensure access_level_id is passed here
      });

      if (res?.status === 200) {
        const accessLevelPermissions = res?.data?.permission_list || [];

        // Create an updated permission object based on the accessLevelPermissions array
        const newPermission = {
          application: permissions[index]?.application || "", // Keep the current application or empty if not set
          access_level: access_level_id, // The selected level
          read: accessLevelPermissions.some(
            (perm) => perm.permission_name === "READ"
          ),
          write: accessLevelPermissions.some(
            (perm) => perm.permission_name === "WRITE"
          ),
          delete: accessLevelPermissions.some(
            (perm) => perm.permission_name === "DELETE"
          ), //this is an automatic permission
        };

        // Update the permissions array at the given index with the full permission object
        const updatedPermissions = [...permissions];
        updatedPermissions[index] = newPermission;

        // Log the updated permission object for debugging
        console.log(
          "Updated Permissions for access_level:",
          updatedPermissions
        );

        // Update the state with the new permission
        setPermissions(updatedPermissions); // Ensure setPermissions is called to update state
      } else {
        console.error("Failed to fetch access_level permissions:", res);
      }
    } catch (error) {
      console.error("Error fetching access_level permissions:", error);
    }
  };
  return (
    <Paper className="permissions-container">
      <TableContainer className="permissions-table-container">
        <Table stickyHeader aria-label="permissions table" size="small">
          <TableHead>
            <TableRow className="permissions-table-header">
              {[
                "Application",
                "Access Level",
                "Restricted",
                "Edit",
                "Delete",
                "",
              ].map((text, index) => (
                <TableCell
                  key={index}
                  className={`permissions-header-cell ${
                    text === "Application" ? "application-header" : ""
                  }`}
                >
                  {text}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {permissions.map((permission, index) => (
              <TableRow key={index} className="permissions-table-row">
                <TableCell className="permissions-cell application">
                  <Select
                    value={permission?.application || ""}
                    onChange={(e) =>
                      handlePermissionChange(
                        index,
                        "application",
                        e.target.value
                      )
                    }
                    size="small"
                    style={{ width: 200 }}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Select App</em>
                    </MenuItem>
                    {appData?.map((app) => (
                      <MenuItem key={app.app_id} value={app.app_id}>
                        {app.app_name}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
                <TableCell className="permissions-cell role">
                  <Select
                    value={
                      fetchedAccessLevels.some(
                        (level) =>
                          level.access_level_id === permission?.access_level
                      )
                        ? permission?.access_level
                        : ""
                    }
                    onChange={(e) => {
                      const access_level_id = e.target.value;
                      console.log(`access_level selected: ${access_level_id}`);
                      handlePermissionChange(
                        index,
                        "access_level",
                        access_level_id
                      );
                      fetchAccessLevelPermissions(access_level_id, index); // Fetch and update permissions
                    }}
                    size="small"
                    style={{ width: 150 }}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Select Access Level</em>
                    </MenuItem>
                    {fetchedAccessLevels?.map((access_level) => (
                      <MenuItem
                        key={access_level?.access_level_id}
                        value={access_level?.access_level_id}
                      >
                        {access_level?.access_level_name}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
                <TableCell className="permissions-cell">
                  <Checkbox
                    checked={!!permission?.read} // Ensure boolean check
                    onChange={(e) =>
                      handlePermissionChange(index, "read", e.target.checked)
                    }
                    disabled={true} // Disable if permissions were set automatically
                  />
                </TableCell>
                <TableCell className="permissions-cell">
                  <Checkbox
                    checked={!!permission?.write} // Ensure boolean check
                    onChange={(e) =>
                      handlePermissionChange(index, "write", e.target.checked)
                    }
                    disabled={true} // Disable if permissions were set automatically
                  />
                </TableCell>
                <TableCell className="permissions-cell">
                  <Checkbox
                    checked={!!permission?.delete} // Ensure boolean check
                    onChange={(e) =>
                      handlePermissionChange(index, "delete", e.target.checked)
                    }
                    disabled={true} // Disable if permissions were set automatically
                  />
                </TableCell>
                <TableCell className="permissions-cell">
                  {permissions?.length > 1 ? (
                    <IconButton
                      className="delete-btn"
                      sx={{ color: "#FF6467" }}
                      onClick={() => handleDeletePermission(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  ) : (
                    <h1></h1>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default EditPermissionsTable;
